import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const Navbar: React.FC = () => {
  const navigate = useNavigate();

  const signOut = async () => {
    await supabase.auth.signOut();
    navigate('/auth');
  };

  const [open, setOpen] = useState(false);

  return (
    <nav className="w-full bg-transparent mt-0 mb-6">
      <div className="max-w-6xl mx-auto px-4 py-3 rounded-lg backdrop-blur-sm bg-white/60 shadow-md border border-white/30 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div onClick={() => navigate('/')} className="flex items-center cursor-pointer">
            <div className="w-9 h-9 rounded-md bg-gradient-to-br from-indigo-500 to-blue-400 flex items-center justify-center text-white font-semibold">BQ</div>
            <span className="ml-3 text-lg font-semibold tracking-tight">ProjectBQO</span>
          </div>
        </div>

        {/* Desktop links */}
        <div className="hidden md:flex items-center space-x-6">
          <NavLink
            to="/create"
            className={({ isActive }) =>
              `text-sm px-3 py-1 rounded-full bg-white/50 hover:bg-white/70 border border-gray-100 shadow-sm transition ${
                isActive ? 'ring-2 ring-indigo-200' : ''
              }`
            }
          >
            Create Lobby
          </NavLink>
          <NavLink
            to="/my-lobbies"
            className={({ isActive }) =>
              `text-sm px-3 py-1 rounded-full bg-white/50 hover:bg-white/70 border border-gray-100 shadow-sm transition ${
                isActive ? 'ring-2 ring-indigo-200' : ''
              }`
            }
          >
            My Lobbies
          </NavLink>
        </div>

        {/* Actions (desktop) */}
        <div className="hidden md:flex items-center space-x-3">
          <button onClick={() => navigate('/')} className="text-sm px-3 py-1 rounded-full bg-white/50 hover:bg-white/70 border border-gray-100 shadow-sm transition">Dashboard</button>
          <button onClick={signOut} className="text-sm px-3 py-1 rounded-full bg-red-50 text-red-700 hover:bg-red-100 transition">Sign out</button>
          <button className="ml-2 w-9 h-9 rounded-full bg-white/70 flex items-center justify-center text-gray-700 shadow-sm">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z" stroke="#374151" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M20 21v-1a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v1" stroke="#374151" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden">
          <button aria-label="Toggle menu" onClick={() => setOpen((s) => !s)} className="p-2 rounded-md bg-gray-100">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 6h14M3 10h14M3 14h14" stroke="#0f172a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile dropdown */}
      <div className={`md:hidden px-4 mt-2 ${open ? 'block' : 'hidden'}`} aria-hidden={!open}>
        <div className="space-y-2">
          <NavLink
            to="/create"
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `block w-full text-sm px-3 py-2 rounded-full bg-white/50 hover:bg-white/70 border border-gray-100 shadow-sm text-center transition ${
                isActive ? 'ring-2 ring-indigo-200' : ''
              }`
            }
          >
            Create Lobby
          </NavLink>
          <NavLink
            to="/my-lobbies"
            onClick={() => setOpen(false)}
            className={({ isActive }) =>
              `block w-full text-sm px-3 py-2 rounded-full bg-white/50 hover:bg-white/70 border border-gray-100 shadow-sm text-center transition ${
                isActive ? 'ring-2 ring-indigo-200' : ''
              }`
            }
          >
            My Lobbies
          </NavLink>
          <div className="flex space-x-2 pt-2">
            <button onClick={() => { setOpen(false); navigate('/'); }} className="flex-1 text-sm px-3 py-2 rounded-full bg-white/50 hover:bg-white/70 border border-gray-100 shadow-sm transition">Dashboard</button>
            <button onClick={() => { setOpen(false); signOut(); }} className="flex-1 text-sm px-3 py-2 rounded-full bg-red-50 text-red-700 hover:bg-red-100 transition">Sign out</button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
